// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import Sidebar from "../../../components/sidebar/Sidebar";
// import SectionHeader from "../../../components/sectionHeader/SectionHeader";
// import MainSection from "../../../components/mainLayout/Main";
// import { getAllDepartments, getAllServices, } from "../../../redux/actions/authActions";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate,useParams } from "react-router-dom";


// function ViewServices() {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const {id}=useParams();
// const departments = useSelector(state=>state.auth.departments);
// const services = useSelector(state=>state.auth.allServices);



//     const [formData, setFormData] = useState({
//         name: "",
//         department:"",
//         compliance:""
//         });

//     useEffect(() => {
//         async function func() {
//             try {
//                 await dispatch(getAllDepartments());
//             } catch (err) {
//                 console.error(err);
//             }
//         }
//         func();
//     }, [dispatch]);


// useEffect(()=>{
//     if(services.length>0){
//     const s=services.find(o=>o?._id===id);
//     if(s)
// setFormData({ name:s.name,department:s.department,compliance:s.compliance})
// }
// else{
//     dispatch(getAllServices());
// }// eslint-disable-next-line 
// },[services])

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.id]: e.target.value });
//         }

//     const handleSelectChange = (value) => {
//         setFormData({
//             ...formData,
//             compliance: value
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             navigate("/services");
//         } catch (error) {
//             console.error("Error in handleSubmit:", error);
//         }
//     };
//     useEffect(() => {
//             console.log(formData.opted);
//         }, [formData]);
    
   
//     // Format services for React-Select
//     const serviceOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }];

//     return (
//         <div>
//             <Sidebar />

//             <MainSection>
//                 <SectionHeader title="View Service" />

//                 <div className="container w-full md:w-1/2 lg:w-1/3 text-start">
//                     <form onSubmit={handleSubmit}>
//                         {/* Name Input */}
//                         <div className="my-5">
//                             <label
//                                 htmlFor="name"
//                                 className="block mb-2 text-sm font-medium text-gray-900"
//                             >
//                                 Service Name
//                             </label>
//                             <input
//                                 type="text"
//                                 id="name"
//                                 value={formData.name}
//                                 onChange={handleChange}
//                                 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
//                                 placeholder="Enter the Services"
//                                 required
//                             />
//                         </div>


//                         {/* Client Type */}
//                         <div className="mb-5">
//                             <label
//                                 htmlFor="department"
//                                 className="block mb-2 text-sm font-medium text-gray-900"
//                             >
//                                 Department
//                             </label>
//                             <select
//                                 id="department"
//                                 onChange={handleChange}
//                                 value={formData.department}
//                                 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
//                                 placeholder="Enter the Department"
//                                 required
//                             >
//                                 {departments && (
//                                     departments.map(d=>(
//                                         <option value={d?._id}>{d?.name}</option>
//                                     ))
//                                 )}
//                                 </select>
//                         </div>



//                         {/* Services Multi-Select */}
//                         <div className="mb-5">
//                             <label
//                                 htmlFor="opted"
//                                 className="block mb-2 text-sm font-medium text-gray-900"
//                             >
//                                 Schedule for Compliance?
//                             </label>
//                             <Select
//                                 id="opted"
//                                 value={{label:formData.compliance ? "Yes" : "No",value:formData.compliance}}
//                                 options={serviceOptions}
//                                 onChange={handleSelectChange}
//                                 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full"
//                                 placeholder="Select services"
//                             />
//                         </div>

//                         {/* Submit Button */} 
//                         <button
//                             type="submit"
//                             className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//                         >
//                             View Service
//                         </button>
//                     </form>
//                 </div>
//             </MainSection>
//         </div>
//     );
// }

// export default ViewServices;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../../components/sidebar/Sidebar";
import SectionHeader from "../../../components/sectionHeader/SectionHeader";
import MainSection from "../../../components/mainLayout/Main";
import { getAllDepartments, getAllServices, updateServiceById } from "../../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { message } from "antd";

function ViewServices() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    // Determine if we are in Edit Mode based on navigation state
    const [isEditMode, setIsEditMode] = useState(location.state?.edit || false);

    const departments = useSelector(state => state.auth.departments);
    const services = useSelector(state => state.auth.allServices);

    const [formData, setFormData] = useState({
        name: "",
        department: "",
        compliance: ""
    });

    // Fetch departments on load
    useEffect(() => {
        dispatch(getAllDepartments()).catch(err => console.error(err));
    }, [dispatch]);

    // Load specific service data into form
    useEffect(() => {
        if (services && services.length > 0) {
            const s = services.find(o => o?._id === id);
            if (s) {
                setFormData({
                    name: s.name,
                    // If department is populated, we need the ID for the select value
                    department: s.department?._id || s.department,
                    compliance: s.compliance
                });
            }
        } else {
            dispatch(getAllServices());
        }
    }, [services, id, dispatch]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSelectChange = (selectedOption) => {
        setFormData({
            ...formData,
            compliance: selectedOption.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // If not in edit mode, the button just takes us back
        if (!isEditMode) {
            navigate("/services");
            return;
        }

        try {
            await dispatch(updateServiceById(id, formData));
            message.success("Service updated successfully");
            navigate("/services");
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            message.error("Failed to update service");
        }
    };

    const serviceOptions = [
        { value: true, label: "Yes" }, 
        { value: false, label: "No" }
    ];

    return (
        <div>
            <Sidebar />

            <MainSection>
                <div className="flex justify-between items-center pr-10">
                    <SectionHeader title={isEditMode ? "Edit Service" : "View Service"} />
                    
                    {/* Mode Switcher for convenience */}
                    <button 
                        onClick={() => setIsEditMode(!isEditMode)}
                        className="text-sm font-semibold text-blue-600 hover:text-blue-800 underline transition-all"
                    >
                        {isEditMode ? "Switch to View Mode" : "Switch to Edit Mode"}
                    </button>
                </div>

                <div className="container w-full md:w-1/2 lg:w-1/3 text-start">
                    <form onSubmit={handleSubmit}>
                        {/* Name Input */}
                        <div className="my-5">
                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
                                Service Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                value={formData.name}
                                onChange={handleChange}
                                disabled={!isEditMode}
                                className={`border text-sm rounded-lg block w-full p-2.5 transition-all ${
                                    !isEditMode 
                                    ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
                                    : "bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500"
                                }`}
                                placeholder="Enter the Services"
                                required
                            />
                        </div>

                        {/* Department Select */}
                        <div className="mb-5">
                            <label htmlFor="department" className="block mb-2 text-sm font-medium text-gray-900">
                                Department
                            </label>
                            <select
                                id="department"
                                onChange={handleChange}
                                value={formData.department}
                                disabled={!isEditMode}
                                className={`border text-sm rounded-lg block w-full p-2.5 transition-all ${
                                    !isEditMode 
                                    ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
                                    : "bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500"
                                }`}
                                required
                            >
                                <option value="">Select Department</option>
                                {departments && departments.map(d => (
                                    <option key={d._id} value={d._id}>{d.name}</option>
                                ))}
                            </select>
                        </div>

                        {/* Compliance Select */}
                        <div className="mb-5">
                            <label htmlFor="opted" className="block mb-2 text-sm font-medium text-gray-900">
                                Schedule for Compliance?
                            </label>
                            <Select
                                id="opted"
                                isDisabled={!isEditMode}
                                value={serviceOptions.find(opt => opt.value === formData.compliance)}
                                options={serviceOptions}
                                onChange={handleSelectChange}
                                className="text-sm"
                                placeholder="Select Status"
                            />
                        </div>

                        {/* Dynamic Action Button */} 
                        <button
                            type="submit"
                            className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                                isEditMode 
                                ? "bg-green-600 hover:bg-green-700 focus:ring-green-500" 
                                : "bg-[#045B9B] hover:bg-[#3385c0] focus:ring-blue-500"
                            }`}
                        >
                            {isEditMode ? "Save Changes" : "Back to Services"}
                        </button>
                    </form>
                </div>
            </MainSection>
        </div>
    );
}

export default ViewServices;
